export const MANAGE_TABS = [{ id: 'content' }, { id: 'connect' }, { id: 'settings' }] as const;

export type ManageTabId = (typeof MANAGE_TABS)[number]['id'];

/** Always land on Content — Connect is opt-in. */
export function defaultManageTab(): ManageTabId {
  return 'content';
}
